import { lazy } from 'react'
import { Bot, Building2, Home, Moon, UserSearch } from 'lucide-react'

/**
 * Bases du CRM : les résultats de toutes les recherches (et les projets auto pour USTS).
 * `module` : droit nécessaire (features/access/modules.js) ; sans `module`, visible par tous.
 * Les écrans sont chargés à la demande : chaque base est un écran complet existant.
 */
export const CRM_BASES = [
  {
    key: 'prospects',
    label: 'Prospects B2B',
    icon: Building2,
    module: 'prospects',
    component: lazy(() => import('../../pages/MyProspects.jsx')),
  },
  {
    key: 'immobilier',
    label: 'Biens immobiliers',
    icon: Home,
    module: 'immobilier',
    component: lazy(() => import('./components/ImmobilierAcquired.jsx')),
  },
  {
    key: 'candidats-ft',
    label: 'Candidats France Travail',
    icon: UserSearch,
    module: 'france_travail',
    component: lazy(() => import('../france-travail-candidates/pages/FranceTravailCandidatesPage.jsx')),
  },
  {
    key: 'projets-auto',
    label: 'Projets auto',
    badge: 'USTS',
    icon: Bot,
    module: 'projects_auto',
    component: lazy(() => import('../../pages/ProjectsAuto.jsx')),
  },
  {
    key: 'relances',
    label: 'Relances',
    icon: Moon,
    component: lazy(() => import('../../pages/DormantProjects.jsx')),
  },
]
